//BOOTH Listing
export const FETCH_BOOTH_LISTING_FAILURE = 'FETCH_BOOTH_LISTING_FAILURE';
export const FETCH_BOOTH_LISTING_SUCCESS = 'FETCH_BOOTH_LISTING_SUCCESS';

export const RESET = 'RESET';
